export interface CalculateOverflowOptions {
	containerWidth: number;
	itemWidths: number[];
	triggerWidth: number;
	gap: number;
}

export interface CalculateOverflowResult {
	splitIndex: number;
	overflowCount: number;
}

/**
 * Two-pass algorithm: first checks if all items fit (no trigger needed),
 * then reserves trigger width and finds the split point. Always shows at least 1 item.
 */
export function calculateOverflow(options: CalculateOverflowOptions): CalculateOverflowResult {
	const { containerWidth, itemWidths, triggerWidth, gap } = options;
	const count = itemWidths.length;

	if (count === 0) {
		return { splitIndex: 0, overflowCount: 0 };
	}

	let totalWidth = 0;

	for (let i = 0; i < count; i++) {
		if (i > 0) totalWidth += gap;
		totalWidth += itemWidths[i]!;
	}

	if (totalWidth <= containerWidth) {
		return { splitIndex: count, overflowCount: 0 };
	}

	const availableWidth = containerWidth - triggerWidth;
	let usedWidth = 0;

	for (let i = 0; i < count; i++) {
		const itemWidth = itemWidths[i]!;
		const gapBefore = i > 0 ? gap : 0;

		if (usedWidth + gapBefore + itemWidth + gap <= availableWidth) {
			usedWidth += gapBefore + itemWidth;
		}
		else {
			const splitIndex = Math.max(1, i);
			return { splitIndex, overflowCount: count - splitIndex };
		}
	}

	return { splitIndex: count, overflowCount: 0 };
}
